import { LoggedBaseComponent }                                from './../../_components/LoggedBaseComponent';
import { Component, OnInit, Output, EventEmitter,Injector }   from '@angular/core';
import User                                                   from '../../models/User';
import { MatDialog }                                          from '@angular/material/dialog';
import { NavigationEnd }                                      from '@angular/router';
import { filter }                                             from 'rxjs/operators';
import { ScreenState }                                        from '../../models/ScreenStateEnum';
import { UtilityService } from 'src/app/_service/utility.service';


@Component({
  providers   : [ ],
  selector    : 'app-header',
  templateUrl : './header.component.html',
  styleUrls   : ['./header.component.css']
})
export class HeaderComponent extends LoggedBaseComponent implements OnInit {

  dark_mode                       : boolean = false;
  current_menu_status             : boolean  = false; //not show
  @Output() toggleSidenav         : EventEmitter<boolean> = new EventEmitter<boolean>();
  activeRoute                     : string = "";
  current_user                    : User = new User({ "username" : "NotLogged"});
  screenState                     : ScreenState = {
                                      mobile: false,
                                      tablet: false,
                                      desktop: true,
                                    };

  header_title                    : string = "";

  constructor(injector : Injector)
  { 
    super(injector);
  }

  getVersion()
  {
    return this.getSettingValue("version_full");
  }

  ngOnInit() 
  {
    this.dark_mode = localStorage.getItem(this.project_labels + "_dark_mode") ? UtilityService.getBoolean(localStorage.getItem(this.project_labels + "_dark_mode")) : false;

    this.header_title = this.getSettingValue('software_name'); //default title is the software name
    this._localStorageService.getWatcher(this.project_labels + "_user_info").subscribe(function(nextValue) 
    {
      if (nextValue !== undefined  && nextValue !== null)
      {
        let parsed_user_info    = JSON.parse(nextValue);
        this.current_user       = new User(parsed_user_info);
      }
      
    }.bind(this));

    this._router.events.pipe(filter(event => event instanceof NavigationEnd)  
    ).subscribe((event: NavigationEnd) => {
      this.activeRoute = event.url.replace("/","");
    });

    this._resizeService.onResize$.subscribe(x => {
      this.screenState = x;
    });

    this.screenState = this._resizeService.checkCurrentSize();

    var user_info = this._localStorageService.getWatchedLocalStorage(this.project_labels + "_user_info");
    if (user_info !== null)
    {
      this.current_user = new User(JSON.parse(user_info));
    }

  }

  toggleSideNav() {
        this._eventEmitterService.updateEmitter("side_menu", !this.current_menu_status);
   }
  
  changeTheme()
  {
      this.dark_mode = !this.dark_mode;
      this._eventEmitterService.updateEmitter("dark_mode", JSON.stringify(this.dark_mode));
  }

  logout()
  {
    this._userService.logout().subscribe(
      data => {
        localStorage.removeItem(this.project_labels + '_user_info');
        sessionStorage.clear();
        window.location.href = "/authportal/ui";
      },
      error => {
        // this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
        localStorage.removeItem(this.project_labels + '_user_info');
        sessionStorage.clear();
        window.location.href = "/authportal/ui";
      });

    // this._userService.logout();
    // this._userService.oidcLogout();
    // this._router.navigate(['']);
  }

  isLogged()
  {
    return this._userService.isLogged();
  }

 

}
